// @mui
import { enUS, heIL } from '@mui/material/locale';
import { getBootstrapData } from '../utils/market';
// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'עברית',
    value: 'he',
    systemValue: heIL,
    icon: '/assets/icons/flags/ic_flag_il.svg',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_us.svg',
  }
];

const bootstrapData = getBootstrapData();
export const defaultLang = allLangs.find((_lang) => _lang.value === bootstrapData.defaultLang) || allLangs[0];